import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { getCurrentUser } from '@/lib/supabaseAdapter';

interface AuthUser {
  id: string;
  email: string;
}

export function useAuthUser() {
  const { data: user = null, isLoading } = useQuery({
    queryKey: queryKeys.auth.currentUser,
    queryFn: async (): Promise<AuthUser | null> => {
      const currentUser = await getCurrentUser();
      if (!currentUser) return null;
      return { id: currentUser.id, email: currentUser.email ?? '' };
    },
  });

  return { user, isLoading };
}
